
import ProfileSvc from '../../../../../services/profile-svc';
let profileSvc = null;
export default {
    props: {
        layout: {
            required: false,
            default: 'chain',
            type: String
        },
        programId: {
            required: false,
            default: 0,
            type: Number
        },
        siteId: {
            required: false,
            default: 0,
            type: Number
        }
    },
    data: () => ({
        fetchedProgram: null,
        loading: false
    }),
    computed: {
        bookingApi() {
            return this.layout == 'portal' ? process.env.VUE_APP_FIXIT_NO_BOOKING_URL : this.$config.VUE_APP_FIXIT_NO_BOOKING_URL ? this.$config.VUE_APP_FIXIT_NO_BOOKING_URL : process.env.VUE_APP_FIXIT_NO_BOOKING_URL
        },
        program() {
            return this.fetchedProgram.program
        }
    },
    async created() {
        this.loading = true
        profileSvc = await ProfileSvc(this.$axios);
        this.fetchedProgram = await profileSvc.GetCustomerProgramById(this.bookingApi, this.layout == 'portal' ? this.$route.params.id : this.programId, this.$route.query.siteId ? this.$route.query.siteId : this.siteId)
        this.loading = false
	},
    beforeDestroy() {
		profileSvc = null
	}
}
